// extracted by mini-css-extract-plugin
export default {"item":"ContactInfoItem_item__Cil6o","icon":"ContactInfoItem_icon__2gf5j","title":"ContactInfoItem_title__fCNsl","linkCaption":"ContactInfoItem_linkCaption__4rt1X"};